module.exports = __webpack_public_path__ + "static/img/userBg.c3a648f4.png";